<template>
  <div 
    @click="horseItemClicked()"
    :class="['horse-item',{'size-small': cfg_size_small}]"
    >

    <div 
      v-if="!status_show_more"
      class="cp"
      @click="showMore()"
      >
      <div class="sp-basic-row ui-card hover-style pr-3">
        <div class="d-flex align-items-center">
          <div class="sp-avatar mr-4">
            <picColored
              class="m-2"
              :img="data.image_url || '/static/img/lion_head.png'"
            />
          </div>
          <div style="flex:1;">
            <div class="d-flex align-items-center w-100">

              <div class="d-flex">
                <div>
                  <span class="mb-0 b">
                    {{data.horse_name}}
                  </span>

                  <span class="ml-4 op4">
                    <!-- Z{{data.genotype}} 
                    {{data.breedtype_str}} -->
                    Gen: {{data.generation}}
                  </span>

                  <span v-if="!cfg_show_breed_row" class="op4">
                    <span class="mx-1 op4">
                      •
                    </span>
                    {{data.gender_str}}
                  </span>
                </div>

              </div>

              <!-- no display for breading list -->
              <div v-if="!cfg_show_breed_row && data.is_in_stud" class="ml-auto">
                <span
                  class="ui-tag-in-stud"
                  >
                  {{lg('',{
                    en: 'IN STUD',
                    zh: '',
                  })}}
                </span>
              </div>

              <div v-if="cfg_give_name_available && !data.name && data.is_my" class="ml-auto">
                <span 
                  class="btn btn-primary"
                  @click.stop="$store.commit('setDataBusKey',{
                    data_on_give_name: data,
                  })"
                  >
                  {{lg('',{
                    en: 'Name',
                    zh: '',
                  })}}
                </span>
              </div>

              <div v-if="cfg_show_breed_row" class="ml-auto">
                <span>
                  {{(data.auctionInfo || {}).timeLeft}}
                </span>
                <span class="ml-4">
                  {{(data.auctionInfo || {}).price}} JGN
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="status_show_more"
      class="anim-fade-in"
      >
      <horseItemMore 
        :data="data"
        @uiPopupBreed="$emit('uiPopupBreed',data)"
        :cfg_show_breed_row="cfg_show_breed_row"
      />
    </div>
  </div>
</template>

<script>
import picColored from '@/views/_cp_base/pic_colored.vue'
import horseItemMore from  './horse_item_more.vue'

export default {
  name: '',
  components: {
    horseItemMore,
    picColored,
  },
  props: [
    'data',
    'cfg_hide_more',
    'cfg_show_breed_row',
    'cfg_size_small',
    'cfg_give_name_available',
  ],
  data() {
    return {
      status_show_more: false,
    }
  },
  computed: {},
  watch: {},
  methods: {

    horseItemClicked(){
      this.$emit('horseItemClicked',this.data)
    },

    showMore(){
      if(this.cfg_hide_more){
        return
      }

      this.$parent.$children.forEach(item => {
        if(item.status_show_more){
          item.status_show_more = false
        }
      })
      this.status_show_more = true
    },
  },
  created() {
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';

  .horse-item{

    &.selected{
      .sp-basic-row{
        border-color: $c;
      }
    }
    &.size-small{
      .sp-avatar{
        width: 50px;
        height: 50px;
      }
    }
    .sp-basic-row{
      border: 1px solid rgba(0,0,0,0.05);
    }
    .sp-avatar{
      width: 80px;
      height: 80px;
    }
  }
</style>